import React from 'react';
import { AppDialog } from '@/components/common/organisms/AppDialog';

interface DocumentViewerProps {
    open: boolean;
    onClose: () => void;
    fileUrl?: string;
    fileName?: string;
}

const DocumentViewer: React.FC<DocumentViewerProps> = ({
    open,
    onClose,
    fileUrl,
    fileName
}) => {
    if (!fileUrl || !fileName) return null;

    const extension = fileName.split('.').pop()?.toLowerCase();

    const isImage = ['jpg', 'jpeg', 'png'].includes(extension || '');
    const isPdf = extension === 'pdf';
    // Browsers render text/plain natively in an iframe, same as pdf.
    const isText = extension === 'txt';
    const canPreview = isImage || isPdf || isText;

    return (
        <AppDialog
            open={open}
            onClose={onClose}
            title={fileName}
            hideConfirmButton={true}
        >
            <div className="flex items-center justify-center p-4">
                {isImage && (
                    <img
                        src={fileUrl}
                        alt={fileName}
                        className="max-w-full max-h-[80vh] object-contain rounded-lg"
                    />
                )}

                {(isPdf || isText) && (
                    <iframe
                        src={fileUrl}
                        title={fileName}
                        className="w-full h-[70vh] rounded-lg bg-white"
                    />
                )}

                {!canPreview && (
                    <div className="text-center">
                        <p className="text-gray-500">
                            Preview is not available for this file type.
                        </p>
                    </div>
                )}
            </div>
        </AppDialog>
    );
};

export default DocumentViewer;